'use client'
import React, { useState, useEffect } from 'react'
import MyImage from '../../myImage'
import PlayIocn from '@/assets/images/icon/play-icon.svg'
import VideoPopUp from '../videoPopup'

function ShortsHeader({ shorts }: any) {
  const [isVideoPopUpOpen, setIsVideoPopUpOpen] = useState({ show: false, id: null })

  useEffect(() => {
    if (isVideoPopUpOpen?.show) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove('overflow-hidden')
    }
  }, [isVideoPopUpOpen])

  return (
    <>
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h6 className="text-base md:text-xl font-bold text-t-origin">Shorts</h6>
        {/* <CustomLink href='/' className='text-sm font-bold text-subSectionText'>
          View all
        </CustomLink> */}
      </div>
      <div className=" overflow-x-auto flex md:grid md:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-6 -mr-3 md:mr-0 pr-3 md:pr-0">
        {shorts?.map((item: any) => {
          return (
            <div
              key={item?._id}
              onClick={() => setIsVideoPopUpOpen({ show: true, id: item?._id })}
              className=" cursor-pointer  min-w-[109px] md:min-w-full w-[109px] md:w-full relative before:w-0 rounded-[14px] overflow-hidden h-[197px] md:h-[385px] before:absolute before:top-0 before:left-0 md:before:w-full before:h-[148px] before:bg-shortsGradientTop before:z-[1] before:rounded-t-[14px] before:opacity-40 after:absolute after:bottom-0 after:left-0 after:w-full after:h-[61px] md:after:h-[148px] after:bg-shortsGradientTop after:z-[1] after:rounded-b-[14px] after:opacity-85 after:rotate-180"
            >
              <span className=" absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 md:transform-none md:top-[18px] md:left-[18px] z-10 w-6 h-6 md:w-7 md:h-7">
                <MyImage src={PlayIocn} width={28} height={28} alt="playiocn" />
              </span>
              <MyImage
                className=" absolute rounded-[14px] top-0 left-0 w-full h-full object-cover"
                width={238}
                height={383}
                src={item?.aThumbnails[2]?.sUrl}
                alt="Shorts"
              />
              <div className="absolute bottom-0 left-0 w-full p-2 md:p-4 z-10">
                <p className="text-[#CED2D5] line-clamp-2 text-xs md:text-base font-medium md:font-bold">
                  {item?.sTitle}
                </p>
              </div>
            </div>
          )
        })}
      </div>
      {isVideoPopUpOpen?.show && (
        <VideoPopUp
          shorts={shorts}
          id={isVideoPopUpOpen?.id || ''}
          onClose={() => setIsVideoPopUpOpen({ show: false, id: null })}
        />
      )}
    </>
  )
}

export default ShortsHeader
